<template>
  <g>
    <g v-if="rand.a.type === hohlschnitt.title">
      <path :d="'M75 75 q30 175 0 350 q175 -30 350 0 q' + cXhohlschnitt + ' ' + cYhohlschnitt + ' -350 -350'" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <polygon v-for="(corner, index) in hohlschnitt.corners" :key="index" :points="corner.point" :transform="'rotate(' + corner.rotate + ')'" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <g v-else>
      <polygon points="75,75 75,425 425,425" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <g>
        <g v-for="side in sides" :key="side.id">
          <g v-if="side.rand === saum">
            <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
            <g v-if="side.rand.oesenArt != inactiveOesen">
              <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
            </g>
          </g>
          <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
          <g v-if="side.rand === keder" stroke="#b1b1b1" stroke-opacity="0">
            <polygon :points="side.keder.outside" fill="#b1b1b1"/>
            <polygon :points="side.keder.inside" fill="#8e8e8e"/>
          </g>
        </g>
      </g>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from '../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      cXhohlschnitt: -175 - Math.sqrt(450),
      cYhohlschnitt: -175 + Math.sqrt(450),
      hohlschnitt: {
        title: DataRand.randArt.hohlschnitt.title.name,
        corners: {
          cornerLU: {
            point: '70,80 70,70 80,70',
            rotate: '20 75 75'
          },
          cornerLD: {
            point: '70,420 70,430 80,430',
            rotate: '0'
          },
          cornerRD: {
            point: '430,420 430,430 420,430',
            rotate: '-20 425 425'
          }
        }
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      keder: DataRand.randArt.keder.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 90,
            xEnd: 410 - Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } else if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M75 395 L395 395',
          hohlsaum: 'M75 416 L416 416',
          keder: {
            outside: '75,416 75,425 425,425 416,416',
            inside: '75,422 75,425 425,425 422,422'
          },
          labelSpace: {
            x: 245,
            y: 485
          },
          border: {
            line: {
              xStart: 75,
              yStart: 445,
              xEnd: 425,
              yEnd: 445
            },
            corner: {
              start: '75,445 85,440 85,450',
              rotateStart: 'rotate(0, 75, 445)',
              end: '425,445 415,440 415,450',
              rotateEnd: 'rotate(0, 425, 445)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            yStart: 90 + Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            yEnd: 410,
            x: function (i, item) {
              return 90
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M105 105 L105 425',
          hohlsaum: 'M84 84 L84 425',
          keder: {
            outside: '75,75 75,425 84,425 84,84',
            inside: '75,75 75,425 78,425 78,78'
          },
          labelSpace: {
            x: 15,
            y: 250
          },
          border: {
            line: {
              xStart: 55,
              yStart: 75,
              xEnd: 55,
              yEnd: 425
            },
            corner: {
              start: '55,75 50,85 60,85',
              rotateStart: 'rotate(0, 55, 75)',
              end: '55,425 50,415 60,415',
              rotateEnd: 'rotate(0, 55, 425)'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 90,
            yStart: 90 + Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            xEnd: 410 - Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            yEnd: 410,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } else if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M75 ' + (75 + this.spaceRand(30, 30)) + ' L' + (425 - this.spaceRand(30, 30)) + ' 425',
          hohlsaum: 'M75 ' + (75 + this.spaceRand(9, 9)) + ' L' + (425 - this.spaceRand(9, 9)) + ' 425',
          keder: {
            outside: '75,75 75,' + (75 + this.spaceRand(9, 9)) + ' ' + (425 - this.spaceRand(9, 9)) + ',425 425,425',
            inside: '75,75 75,' + (75 + this.spaceRand(3, 3)) + ' ' + (425 - this.spaceRand(3, 3)) + ',425 425,425'
          },
          labelSpace: {
            x: 275,
            y: 225
          },
          border: {
            line: {
              xStart: 75 + Math.sqrt(200),
              yStart: 75 - Math.sqrt(200),
              xEnd: 425 + Math.sqrt(200),
              yEnd: 425 - Math.sqrt(200)
            },
            corner: {
              start: (75 + Math.sqrt(200)) + ',' + (75 - Math.sqrt(200)) + ' ' + (70 + Math.sqrt(200)) + ',' + (85 - Math.sqrt(200)) + ' ' + (80 + Math.sqrt(200)) + ',' + (85 - Math.sqrt(200)),
              rotateStart: 'rotate(-45, ' + (75 + Math.sqrt(200)) + ',' + (75 - Math.sqrt(200)) + ')',
              end: (425 + Math.sqrt(200)) + ',' + (425 - Math.sqrt(200)) + ' ' + (420 + Math.sqrt(200)) + ',' + (415 - Math.sqrt(200)) + ' ' + (430 + Math.sqrt(200)) + ',' + (415 - Math.sqrt(200)),
              rotateEnd: 'rotate(-45, ' + (425 + Math.sqrt(200)) + ',' + (425 - Math.sqrt(200)) + ')'
            }
          },
          id: 3
        }
      }
    }
  }
}
</script>

<style>
</style>
